export default __webpack_public_path__ + "img/client-supplier.cd8e8c0e.svg";